export function getListeningAudioStrategy(sections = [], topLevelAudioUrl = null) {
  const parts = (Array.isArray(sections) ? sections : []).map((section, index) => ({
    part: index + 1,
    url: section?.audio_url || null,
  }));
  const availableParts = parts.filter((item) => item.url);
  const allPartsHaveAudio = parts.length === 4 && availableParts.length === 4;
  const uniqueAudioCount = new Set(availableParts.map((item) => item.url)).size;
  const allPartsShareAudio = allPartsHaveAudio && uniqueAudioCount === 1;
  const allPartsHaveUniqueAudio = allPartsHaveAudio && uniqueAudioCount === 4;

  if (allPartsShareAudio) {
    return { kind: 'continuous', url: availableParts[0].url };
  }

  if (allPartsHaveUniqueAudio) {
    return { kind: 'parts', parts };
  }

  if (topLevelAudioUrl) {
    return { kind: 'continuous', url: topLevelAudioUrl };
  }

  if (uniqueAudioCount === 1) {
    return { kind: 'continuous', url: availableParts[0].url };
  }

  return { kind: 'unavailable', parts: [] };
}

export function getListeningAudioSource(strategy, partNumber) {
  if (strategy?.kind === 'continuous') return strategy.url || null;
  if (strategy?.kind !== 'parts') return null;

  const part = Number(partNumber);
  return strategy.parts.find((item) => item.part === part)?.url || null;
}
